module.exports = __webpack_public_path__ + "static/media/top-up-icon.90d1e75a.svg";